import _omit from 'lodash/omit'
import _pick from 'lodash/pick'

const module = {
  namespaced: true,
  state: () => ({
    me: {
      nick: '',
      photo: null,
      count: null,
    },
    meList: [],
    overview: { city: 0, trip: 0 },
    breadcrumbs: [],
    popularList: [],
    popularCities: [],
    filters: {},
    //relatedProducts: [],
    //recommendProducts: [],
    itinerary: {},
    replies: {
      criteria: { paging: { no: 1, limit: 5, total: 0 } },
      list: [],
    },
    gifCount: 0,
  }),
  getters: {
    overview: (state) => state.overview,
    breadcrumbs: (state) => state.breadcrumbs,
    popularList: (state) => state.popularList,
    itinerary: (state) => state.itinerary,
    filters: (state) => state.filters,
    //relatedProducts: state => state.relatedProducts,
    //recommendProducts: state => state.recommendProducts,
    replies: (state) => state.replies,
    popularCities: (state) => state.popularCities,
    gifCount: (state) => state.gifCount,
  },
  actions: {
    async overview({ commit }) {
      try {
        const { data } = await this.$http.get('/trip/v1/overview')
        commit('setOverview', data)
      } catch (err) {
        console.log(err)
      }
    },
    async popularList({ commit }, params) {
      try {
        const { data } = await this.$http.get('/trip/v1/popular-pick', { params })
        commit('setPopularPick', data)
      } catch (err) {
        console.log(err)
      }
    },
    async mainList({ commit }, criteria) {
      try {
        if (criteria.period && criteria.period.limit) {
          criteria.period.limit = undefined
        }
        if (criteria.paging.total) {
          criteria.paging.total = undefined
        }
        if (typeof criteria.city === 'string' && criteria.city.toLowerCase() === 'all') {
          criteria.city = undefined
        }

        const { data } = await this.$http.post('/trip/v1/list', criteria)

        return data
      } catch (err) {
        console.log(err)
      }
    },
    async detail({ commit }, code) {
      try {
        const { data } = await this.$http.get(`/trip/v1/detail/${code}`)
        commit('setDetail', data)
      } catch (err) {
        console.log(err)
      }
    },
    /*
    async relatedProducts ({commit}, code) {
      const {data} = await this.$http.get(`/trip/v1/detail/${code}/product`);
      commit('setRelatedProducts', data);
    },
    async recommendProducts ({commit}, _data) {
      const {data} = await this.$http.post(`/platform/v1/city-product`, _data);
      commit('setRecommandProducts', data);
    },
    */

    async filters({ commit }) {
      try {
        const { data } = await this.$http.get('/trip/v1/filter')
        commit('setFilters', data)
      } catch (err) {
        console.log(err)
      }
    },
    async getPopularCities({ commit }) {
      try {
        const { data } = await this.$http.get('/platform/v1/city-popular', {
          params: { limit: 20 },
        })
        commit('setPopularCities', data)
      } catch (err) {
        console.log(err)
      }
    },
    async getMe({ commit }) {
      try {
        const { data } = await this.$http.get('/trip/v1/me')
        commit('setMe', data)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    async getMeList({ commit }, params) {
      try {
        params.paging.total = undefined
        const { data } = await this.$http.post('/trip/v1/me-list', params)
        commit('setMeList', { data, reset: params.paging.no == 1 })
        return data
      } catch (err) {
        console.log(err)
      }
    },
    async replies({ commit }, { code, params }) {
      try {
        const { data } = await this.$http.post(`/trip/v1/detail/${code}/reply-list`, params)
        commit('setReplies', data)
      } catch (err) {
        console.log(err)
      }
    },
    async deleteItinerary({ commit }, code) {
      try {
        const response = await this.$http.delete(`/trip/v1/edit/${code}`)
        if (response.status == 200) {
          commit('removeItinerary', code)
        }
      } catch (err) {
        console.log(err)
      }
    },
    newReply({ commit }, { code, reply }) {
      return this.$http.post(`/trip/v1/detail/${code}/reply`, _omit(reply, 'nick'))
    },
    editReply({ commit }, { code, reply }) {
      return this.$http.put(`/trip/v1/detail/${code}/reply/${reply.key}`, _pick(reply, 'content'))
    },
    deleteReply({ commit }, { id, key, parentKey }) {
      return this.$http
        .delete(`/trip/v1/detail/${id}/reply/${key}${parentKey ? '/' + parentKey : ''}`)
        .then(({ data }) => data)
    },
    save({ commit }, _data) {
      return this.$http.put(`/trip/v1/edit/${_data.id}`, _omit(_data, 'id'), {
        useAuth: true,
        sellerToken: _data.sellerToken,
      })
    },
  },
  mutations: {
    setOverview(state, item) {
      state.overview = item
    },
    setPopularPick(state, items) {
      state.popularList = items
    },
    setDetail(state, item) {
      state.itinerary = item
    },
    setLikeItinerary(state, data) {
      state.itinerary.popular = true
      state.itinerary.count.popular = data.total
    },
    setUnlikeItinerary(state, data) {
      state.itinerary.popular = false
      state.itinerary.count.popular = data.total
    },
    setFilters(state, data) {
      state.filters = data
    },
    /*
    setRelatedProducts (state, data) {
      state.relatedProducts = data;
    },
    */

    setPopularCities(state, data) {
      state.popularCities = data
    },
    setReplies(state, data) {
      state.replies = data
    },
    /*
    setRecommandProducts (state, data) {
      state.recommendProducts = data;
    },
    */
    setMe(state, data) {
      state.me = data
    },
    setMeList(state, { data, reset }) {
      state.meList = reset ? data.list : [...state.meList, ...data.list]
    },
    removeItinerary(state, code) {
      state.meList = (state.meList || []).filter((item) => item.id != code)
    },
    setGifCount(state, data) {
      if (data === 'increment') {
        state.gifCount++
      }
      if (data === 'decrement') {
        state.gifCount--
      }
      if (data === 'reset') {
        state.gifCount = 0
      }
    },
  },
}

export default module
